import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '@pg-env/environment';

@Injectable({
  providedIn: 'root'
})
export class PaymentHistoryService {
  api: string;

  constructor(private http: HttpClient) {
    this.api = environment.customerApiUrl;
  }

  getPaymentHistory(data: any): Observable<any> {
    return this.http.post(`${this.api}/payment/search-payment-history`, data);
  }

  getChartData(data: any): Observable<any> {
    return this.http.post(`${this.api}/Payment/get-payment-history-char`, data);
  }

  getReportColumns(params): Observable<any> {
    return this.http.post(`${this.api}/client-report/get-report-columns`, params);
  }

  updateReportColumns(data: any): Observable<any> {
    return this.http.post(`${this.api}/client-report/update-report-columns`, data);
  }

  // /export-payment-histories-table
  downloadExcel(data: any): Observable<any> {
    return this.http.post(`${this.api}/Payment/export-payment-histories-table`, data, { responseType: 'blob' });
  }
}
